import { render, staticRenderFns } from "./read.vue?vue&type=template&id=61743c86&scoped=true"
import script from "./read.vue?vue&type=script&lang=js"
export * from "./read.vue?vue&type=script&lang=js"
import style0 from "./read.vue?vue&type=style&index=0&id=61743c86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61743c86",
  null
  
)

export default component.exports